export default __webpack_public_path__ + "static/media/002-crane.707f5c86.svg";